
// shader that swaps color from the texture to a color from the palette texture.
export const fragment = `
precision highp float;

uniform sampler2D texture;
uniform sampler2D palette_texture;

varying vec2 v_uv;

void main() {
    vec4 color = texture2D(texture, v_uv);
    float palette_index = (color.r + color.g + color.b) / 3.0;
    vec4 palette_color = texture2D(palette_texture, vec2(palette_index, 0.5));
    gl_FragColor = vec4(palette_color.rgb, color.a);
}
`;